var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 43.4C29.2 43.8 29.1 37.8 26.7 36.8C24.3 35.8 22 36.7 21.3 39C20.5 41.3 22.4 43.3 24.4 43.4Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 30.1C35.5 29.7 34.4 27 32.2 18.6C30 10.3 23.8 4.99997 16.1 6.89997L15.5 7.09997C8 9.29997 5.3 17 7.6 25.3C9.8 33.6 10.3 36.5 9.1 37.7C7.9 38.9 8.6 40.8 12.2 40.5C20.2 39.8 31.4 36.5 36.4 33.7C38.9 32.2 38.5 30.4 37.1 30.1Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 1.79996C10.3 3.09996 12 8.99996 15.8 8.69996C15.8 8.69996 17 8.69996 18.2 7.39996C20.4 4.79996 17 0.499958 13.7 1.79996ZM17.2 6.19996C16.1 7.19996 14.8 6.99996 14.3 6.19996C13.7 5.39996 13.4 3.49996 14.7 3.19996C16.3 2.59996 18.3 5.19996 17.2 6.19996Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39999 26.2C16 24.2 24.4 22 32.7 19.1C29.1 21.7 24.8 23.2 20.5 24.5C16.3 25.5 11.9 26.4 7.39999 26.2Z",
    fill: "#FF931E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10001 28.9999C16.7 26.9999 25.1 24.7999 33.4 21.8999C29.8 24.4999 25.5 25.9999 21.2 27.2999C17 28.2999 12.5 29.1999 8.10001 28.9999Z",
    fill: "#FF931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3f62643d808765b6609bc0769a62bbf8.svg";
export { ForwardRef as ReactComponent };